import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './background_box.module.scss';

type Props = {
  className?: string;
};

export const BackgroundBox: FC<Props> = ({ className, children }) => (
  <div className={classNames(styles.container, className)}>{children}</div>
);
